__turbopack_context__.v({
  "container": "progresschecklist-module-scss-module__lFIHDW__container",
  "list": "progresschecklist-module-scss-module__lFIHDW__list",
  "listItem": "progresschecklist-module-scss-module__lFIHDW__listItem",
  "username": "progresschecklist-module-scss-module__lFIHDW__username" + " " + "text-small",
});
